module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-3-204651ac8913526b2e13190d557fadc3.webp";